import { render } from "./App.vue?vue&type=template&id=a12da684"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Desktop\\EBOOK\\backend\\upload\\1789976864\\vuebook\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__